"use client";

import React, { useRef, useState, useEffect } from "react";
import Image from "next/image";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
import {
  ClickstreamInterface,
  logClickstreamEvent,
} from "@packages/lib/utlils/clickstream";
import { ClickstreamConstants, GAConstants } from "@packages/shared-components/services/constants";
import { ContentfulInspectorManager } from "@packages/lib/contentful-preview/ContentfulInspector";
import { GA4DataLayer } from "@packages/lib/utlils/helper-function";
interface VideoProps {
  featuredData?: {
    mediaPath: string;
    mediaName?: string;
    thumbnailPath?: string;
    thumbnailUrl?: string;
    position?:any
  };
  csData?: any;
  lazyLoadThumbnail?: boolean;
  videoSysId?: string;
  imageSysId?: string;
  iscontentPreview?: boolean;
  commonGAAttrs?:any;
}

const Video = ({
  featuredData,
  csData,
  lazyLoadThumbnail = true,
  videoSysId,
  imageSysId,
  iscontentPreview,
  commonGAAttrs,
}: VideoProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isVideoPlayerLoaded, setIsVideoPlayerLoaded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    emitter.on("pauseVideo", onClickPause); // while click the filter button
    return () => {
      emitter.off("pauseVideo", onClickPause);
    };
  }, []);

  useEffect(() => {
    if (isVideoPlayerLoaded && videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play().catch((err) => {
        console.warn("Video play failed", err);
      });
    }
  }, [isVideoPlayerLoaded]);

  const featuredClickstreamEvent = () => {
    let updatedClickstreamData: ClickstreamInterface;
    updatedClickstreamData = {
      ...csData,
      eventType: "VideoPlayed",
      functionalityName: "Featured provider",
      actionType: ClickstreamConstants.clickAction,
      videoName: featuredData?.mediaName,
    };
    updatedClickstreamData && logClickstreamEvent(updatedClickstreamData);
  };

  const loadPlayer = () => {
    setIsVideoPlayerLoaded(true);
    setIsPlaying(true);
  };

  const onPlay = (event: React.FormEvent) => {
    event.stopPropagation();
    if (videoRef.current && !isPlaying) setIsPlaying(true);
  };

  const onClickPause = (event: React.FormEvent) => {
    event.stopPropagation();
    if (videoRef.current && isPlaying) {
      videoRef.current.pause(); // Pause the video
      setIsPlaying(false);
    }
  };

  const handleVideoClick = (event: React.FormEvent) => {
    event.stopPropagation(); // Prevents the parent onClick from being triggered
  };
  console.log(
    "update",
    `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}${featuredData?.thumbnailPath}`
  );
  return (
    <>
      {iscontentPreview && (
        <ContentfulInspectorManager
          fields={[
            {
              entryId: videoSysId,
              fieldId: "video",
              targetSelector: "#cpc_video",
            },
            {
              entryId: imageSysId,
              fieldId: "image",
              targetSelector: "#cpc_image",
            },
          ]}
        />
      )}
      {isVideoPlayerLoaded ? (
        <video
          ref={videoRef}
          className="w-full"
          controls
          controlsList="nodownload"
          preload="none"
          onClick={(event) => {
            handleVideoClick(event);
            !isPlaying && featuredClickstreamEvent();
            GA4DataLayer({
                            event: GAConstants.track_event,
                            event_name: "video_click",
                            click_text: featuredData?.mediaName,
                            position:featuredData?.position,
                            ...commonGAAttrs
                          });
          }}
          onPlay={(event) => {
            onPlay(event);
            !isPlaying && featuredClickstreamEvent();
          }}
          onPause={(event) => onClickPause(event)}
          poster={
            featuredData?.thumbnailUrl ||
            `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}${featuredData?.thumbnailPath}`
          }
        >
          <source
            id="cpc_video"
            src={featuredData?.mediaPath ? `${featuredData?.mediaPath}` : "/"}
            type="video/mp4"
          />
        </video>
      ) : (
        <>
          <div className="w-full relative rounded-[8px] overflow-hidden block">
            {!!(featuredData?.thumbnailPath || featuredData?.thumbnailUrl) && (
              <Image
                className="block w-full"
                src={
                  featuredData?.thumbnailUrl
                    ? featuredData.thumbnailUrl
                    : `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}${featuredData?.thumbnailPath}`
                }
                alt="Video thumbnail"
                width={907}
                height={511}
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                quality={80}
                priority={true}
                placeholder="blur"
                blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiNlMmUyZTIiLz48L3N2Zz4="
              />
            )}
            <button
              type="button"
              onClick={() => {
                loadPlayer();
                GA4DataLayer({
                  event: GAConstants.track_event,
                  event_name: "video_click",
                  click_text: featuredData?.mediaName,
                  ...commonGAAttrs
                });
              }}
              className="video-play-icon absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
              aria-label="Play Video"
            >
              <Image
                src="/static/assets/icons/video_play_icon.svg"
                width={52}
                height={52}
                alt="Play icon"
              />
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default Video;
